import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m190.7 154.9-54.3-54.5c3.6-8 5.3-17 5.3-26.8C141.7 34.2 110.6 2 71.4 2 59 2 48.3 5.6 37.6 10.9l40 40.2c2.7 2.7 2.7 7.2 0 9.8L59.8 79.8c-2.7 2.7-7.1 2.7-9.8 0L10.9 38.7C5.6 49.4 2 61 2 72.6c0 39.3 31.1 71.5 70.3 71.5 10.7 0 20.5-2.7 30.3-7.2l52.5 53.6c9.8 9.8 25.8 9.8 34.7 0l.9-.9c9.7-8.8 9.7-24.9 0-34.7z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}